import React from "react";

export default function useInterval(callback: () => void | Promise<void>, delay: number): void {
  const savedCallback = React.useRef<(() => void | Promise<void>) | undefined>(undefined);

  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  React.useEffect(() => {
    let callbackRunning = false;

    async function tick(): Promise<void> {
      if (!callbackRunning && savedCallback.current != null) {
        callbackRunning = true;
        try {
          await savedCallback.current();
        } finally {
          callbackRunning = false;
        }
      }
    }

    if (delay != null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
